export default __webpack_public_path__ + "static/media/section2-img3.4bd2b310.png";